import API from '@/lib/API.js'
import comun from './comun.js'
const prorrogas = {
    namespaced: true,
    state: {
        Lista: [],
        Filtradas: [],
        Seleccionado: undefined
    },
    mutations: {
        init(state) {
            state.Filtradas = [];
            state.Seleccionado = undefined;
        },
        set(state, payload) {
            state.Lista = payload;
        },
        select(state, payload) {
            state.Seleccionado = payload;
        },
    },
    actions: {
        async set({
            commit,
            getters
        }) {
            let entidades = getters.getProrrogas();
            if (entidades.length === 0) {
                commit("comun/cargando")
                let data = await API.Prorrogas.traerTodos();
                commit("set", data)
                commit("comun/fincarga")
            }
        },
        select({
            commit
        }, payload) {
            commit("select", payload)
        },
        selectPorId({
            commit,
            state
        }, payload) {
            commit("comun/cargando")
            let sec = state.Lista.find((x) => x.Id == payload)
            commit("select", sec)
            commit("comun/fincarga")
        },
        setNuevo({
            commit
        }) {
            commit("comun/cargando")
            let sec = {
                Id: 0,
                Descripcion_prorroga: ""
            }
            commit("select", sec)
            commit("comun/fincarga")
        },
        async guardar({
            commit,
            dispatch,
            state
        }) {
            let data = []
            let str = ""
            if (state.Seleccionado.Id != 0) {
                data = await API.Prorrogas.modificar(state.Seleccionado);
                str += "Prorroga modificada"
            } else {
                data = await API.Prorrogas.alta(state.Seleccionado);
                str += `Nueva prorroga de alta`
            }
            let secs = await API.Prorrogas.traerTodos();
            commit("set", secs)
            dispatch("selectPorId", data.Id)
            commit("comun/mostrar", str)
        },
        async guardarEntidad({
            commit,
            dispatch
        }, entidad) {
            let data = []
            let str = ""
            if (entidad.Id != 0) {
                entidad = await API.Prorrogas.modificar(entidad);
                str += "Prorroga modificada"
            } else {
                entidad = await API.Prorrogas.alta(entidad);
                str += `Nueva prorroga de alta`
            }
            commit("comun/mostrar", str)
            return entidad;
        },
        async eliminar({
            commit
        }, id) {
            let str = ""
            if (id != 0) {
                await API.Prorrogas.eliminar(id);
                str += "Prorroga eliminada"
            }
            let ents = await API.Prorrogas.traerTodos();
            commit("set", ents)
            commit("comun/mostrar", str)
        },
    },
    getters: {
        getProrrogas: state => () => {
            return state.Lista;
        },
    },
    modules: {
        comun,
    }
}
export default prorrogas;